import { render, staticRenderFns } from "./WebLinkTrafalgar.vue?vue&type=template&id=25316a21&scoped=true&"
import script from "./WebLinkTrafalgar.vue?vue&type=script&lang=js&"
export * from "./WebLinkTrafalgar.vue?vue&type=script&lang=js&"
import style0 from "./WebLinkTrafalgar.vue?vue&type=style&index=0&id=25316a21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25316a21",
  null
  
)

export default component.exports